import { cn } from '@/lib/utils'
import { CSSProperties } from 'react'

interface MarqueeProps {
  className?: string
  reverse?: boolean
  pauseOnHover?: boolean
  children?: React.ReactNode
  vertical?: boolean
  repeat?: number
  duration?: string
  gap?: string
  [key: string]: any
}

export default function Marquee({
  className,
  reverse,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  duration = '40s',
  gap = '1rem',
  ...props
}: MarqueeProps) {
  const containerStyle: CSSProperties = {
    display: 'flex',
    overflow: 'hidden',
    padding: '0.5rem',
    gap: gap,
    flexDirection: vertical ? 'column' : 'row',
    ['--duration' as string]: duration,
    ['--gap' as string]: gap,
  }

  const itemStyle: CSSProperties = {
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'space-around',
    gap: gap,
    flexDirection: vertical ? 'column' : 'row',
    animationDirection: reverse ? 'reverse' : 'normal',
  }

  return (
    <div {...props} className={cn('marquee-container', className)} style={containerStyle}>
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={cn(
              vertical ? 'animate-marquee-vertical' : 'animate-marquee',
              pauseOnHover && 'marquee-pause-on-hover',
            )}
            style={itemStyle}
          >
            {children}
          </div>
        ))}
    </div>
  )
}
